(ns hai.library.documents.routes
  (:require
   [hai.ui.components :as c]
   [hai.ui.icons :as icons]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Documents 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/documents" {:name :documents
                  ::routing/window-title "Documents"
                  :label "Manage Knowledge"
                  :icon icons/outlined-psychology
                  :view page}]])
